import { TransactionsTableMeta } from "@/components/transactions/Transactions";
import { ConfirmDelete } from "@/shared/confirmDelete/ConfirmDelete";
import { Row, Table } from "@tanstack/react-table";
import { Trash } from "lucide-react";
import { useState } from "react";

interface DataTableRowActionsProps<TData> {
    row: Row<TData>,
    table: Table<TData>
}
export function TransactionsTableRowActions<TData>({ row, table }: DataTableRowActionsProps<TData>) {
    const { deleteTransaction } = table.options.meta as TransactionsTableMeta;
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);

    return (
        <div>
            <button className="row-actions__trigger-button" onClick={() => setIsDeleteOpen(true)}>
                <Trash width={16} height={16    } />
            </button>
            {isDeleteOpen && <div className="overlay">
                <ConfirmDelete
                    type="Transaction"
                    action="Delete"
                    id={`${row.getValue("id")}`}
                    onClose={() => setIsDeleteOpen(false)}
                    onDelete={async () => {
                        await deleteTransaction(row.getValue("id"), row.getValue("invoiceNumber"));
                    }}
                />
            </div>}
        </div>
    )
}